import { notify } from '@affine/component';
import { UserFriendlyError } from '@affine/error';
import { useI18n } from '@affine/i18n';
import { useService } from '@toeverything/infra';
import { useCallback } from 'react';

import { ObjectAccessRequestService } from '../services/object-access-request';

/** Locked (metadata-only) folder notice with a "Request access" action. */
export function useFolderNoAccessNotice() {
  const t = useI18n();
  const requests = useService(ObjectAccessRequestService);
  return useCallback(
    (folderId: string) => {
      notify.warning({
        title: t['com.streamlain.rootAppSidebar.organize.folder-no-access'](),
        actions: [
          {
            key: 'request-access',
            label: t['com.streamlain.permissions.accessRequest.request'](),
            onClick: async () => {
              try {
                const result = await requests.request(
                  { kind: 'folder', id: folderId },
                  'Reader'
                );
                notify.success({
                  title:
                    result.status === 'already_allowed'
                      ? t['com.streamlain.permissions.accessRequest.allowed']()
                      : t['com.streamlain.permissions.accessRequest.sent'](),
                });
              } catch (cause) {
                notify.error({
                  title: t['com.streamlain.permissions.accessRequest.failed'](),
                  message: UserFriendlyError.fromAny(cause).message,
                });
              }
            },
          },
        ],
      });
    },
    [requests, t]
  );
}
